import { Grid, ButtonBase, Typography, Paper } from '@material-ui/core';
import React, { FC } from 'react';
import styled from 'styled-components';
import RemoveLineItemButton from 'components/SalesArea/pages/Cart/Container/RemoveLineItemButton';
import UpdateLineItemSelector from 'components/SalesArea/pages/Cart/Container/UpdateLineItemSelector';
import { CheckoutLineItem } from 'graphql/shopify-store-front-api/queries/types';

/**
 * カードのスタイル
 */
// const StyledCard = styled(Card)`
//   max-width: 800;
//   width: 100%;
//   margin: 5px 0px;

//   .card-media {
//     width: 10%;
//   }
// `;

/**
 *  商品名と数量変更セレクタのスタイル
 */
// const StyledTitleAndSelector = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   flex-grow: 10;
// `;

/**
 *  金額と商品削除ボタンのスタイル
 */
// const StyledPriceAndButton = styled.div`
//   flex-wrap: wrap;
// `;

/**
 * 商品名のスタイル
 */
const StyledTitle = styled.div`
  width: 100%;
  margin-top: 0.5rem;

  @media screen and (max-width: 751px) {
    h6 {
      font-size: 4vw;
    }
  }
`;

/**
 * 商品金額のスタイル
 */
const StyledPrice = styled.div`
  padding-left: 10px;
  padding-bottom: 0.5rem;

  h5 {
    font-weight: bold;
  }

  @media screen and (max-width: 751px) {
    padding-left: 10px;
    padding-bottom: 0.5rem;

    h5 {
      font-size: 5vw;
    }
  }
`;
/**
 * 商品説明テキストのスタイル
 */
const StyledText = styled.div`
  padding-left: 10px;
  padding-bottom: 0.5rem;

  @media screen and (max-width: 751px) {
    padding-left: 10px;

    p {
      font-size: 2vw;
    }
  }
`;

/**
 * 商品削除ボタンのスタイル
 */
const StyledRemoveLineItemButton = styled.div`
  margin: 0px 10px;
`;

/**
 * 数量変更セレクタのスタイル
 */
const StyledUpdateLineItemSelector = styled.div`
  margin: 0.3rem;
`;

/**
 * カードのスタイル
 */
const CartItemImg = styled.img`
  max-width: 100%;
`;

const StyledLineItem = styled.div`
  margin: 10px;
`;

// const StyledTest = styled.div`
//   display: flex;

//   .card-media {
//     width: 100px;
//     size: auto;
//     margin: 5px;

//     @media screen and (max-width: 751px) {
//       width: 50px;
//       height: fit-content;
//     }
//   }
// `;

export type Props = {
  /**
   * カードに表示するカート中の商品情報
   */
  lineItem: CheckoutLineItem;
};

/**
 * カートに保存中の商品を表示するカード
 */
const LineItemCard: FC<Props> = ({ lineItem }) => {
  return (
    <>
      <StyledLineItem>
        <Paper>
          <Grid container spacing={2}>
            <Grid
              item
              xs={5}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <ButtonBase>
                <CartItemImg
                  src={String(lineItem.variant?.image?.originalSrc)}
                />
              </ButtonBase>
            </Grid>
            <Grid
              item
              xs={7}
              sm
              container
              direction="column"
              alignItems="flex-start"
              justify="center"
            >
              <StyledTitle>
                <Typography gutterBottom variant="h6">
                  {lineItem.title}
                  {lineItem.variant?.title === 'Default Title'
                    ? ''
                    : `／${lineItem.variant?.title ?? ''}`}
                </Typography>
              </StyledTitle>
              <StyledPrice>
                <Typography variant="h5">
                  ¥
                  {(
                    lineItem.quantity * Number(lineItem.variant?.priceV2.amount)
                  ).toLocaleString()}
                </Typography>
              </StyledPrice>
              <StyledText>
                {/* <Typography gutterBottom>
                  賞味期限 : 製造から冷凍で180日間
                </Typography> */}
                <Typography gutterBottom>
                  送料：道外配送のみ数量 × 600円（税込）
                </Typography>
              </StyledText>
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center">
            <Grid
              item
              xs={5}
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <StyledUpdateLineItemSelector>
                <UpdateLineItemSelector
                  lineItemId={lineItem.id}
                  variantId={lineItem.variant?.id ?? ''}
                  quantity={lineItem.quantity}
                />
              </StyledUpdateLineItemSelector>
            </Grid>
            <Grid
              item
              xs={7}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <StyledRemoveLineItemButton>
                <RemoveLineItemButton lineItemId={lineItem.id} />
              </StyledRemoveLineItemButton>
            </Grid>
          </Grid>
        </Paper>
      </StyledLineItem>
    </>
  );
};

export default LineItemCard;
